import { render } from "./WorkCalendar.vue?vue&type=template&id=3439adac"
import script from "./WorkCalendar.vue?vue&type=script&lang=js"
export * from "./WorkCalendar.vue?vue&type=script&lang=js"

import "./WorkCalendar.vue?vue&type=style&index=0&id=3439adac&lang=scss"
script.render = render

export default script